// extracted by mini-css-extract-plugin
module.exports = {"featured__carousel":"styles_featured__carousel__5xVmr"};